import AOS from 'aos';

export default class PageLoader {
    constructor(element) {

        window.addEventListener('load', (event) => {
            setTimeout(() => {
                this.fadeOut(element);
            }, 500);

            setTimeout(() => {
                AOS.init();
            }, 1000);
        });
    }

    fadeOut(el) {
        el.style.opacity = 1;
        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    };
}